import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';
import withoutNulls from '../../api/search/withoutNulls';

const APPS_DOC = 'general-apps';
const CURRENT_VERSION = 'v1';

const appConverter = {
  toFirestore(app: V3.GeneralApp): firebase.firestore.DocumentData {
    return withoutNulls({ ...app });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<V3.GeneralApp>,
    options: firebase.firestore.SnapshotOptions,
  ): V3.GeneralApp {
    const data: V3.GeneralApp = {
      ...snapshot.data(options),
    };

    const app: V3.GeneralApp = {
      ...data,
      appViewersAccess: data.appViewersAccess
        ? data.appViewersAccess
        : {
            isPublic: false,
            userIds: [],
            groupIds: [],
          },
      adminUserIds: data.adminUserIds ? data.adminUserIds : [],
    };

    return app;
  },
};

const getGeneralAppsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.CONTENT_DISTRIBUTIONS_COLLECTION)
    .doc(APPS_DOC)
    .collection(CURRENT_VERSION)
    .withConverter(appConverter);
};

export default getGeneralAppsRef;
